import React, { useEffect, useState } from 'react';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LoadingButton from '@mui/lab/LoadingButton';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import moment from 'moment';
import { Typography, Button, Paper, Box } from '@mui/material';

import http from '../../../api/http';
import Modal from '../../Modal';

const loadNotifications = async (pageNum = 1) => {
    try {
        const response = await http.get('/activity-logs', {
            params: { q: 'recent', pageNum },
        });
        return response.data?.data || [];
    } catch (error) {
        return [];
    }
};

function ModalNotifications({ openModal, closeModal }) {
    const [loading, setLoading] = useState(false);
    const [userNotifications, setUserNotifications] = useState({
        page: 1,
        notificationsList: [],
        dataSize: 0,
    });

    useEffect(() => {
        if (!openModal) {
            return;
        }

        let cancelled = false;

        const fetchPage = async () => {
            setLoading(true);
            const notificationsList = await loadNotifications(userNotifications.page);
            if (cancelled) {
                return;
            }
            setUserNotifications((current) => ({
                page: current.page,
                notificationsList:
                    current.page > 1
                        ? current.notificationsList.concat(notificationsList)
                        : notificationsList,
                dataSize: notificationsList.length,
            }));
            setLoading(false);
        };

        fetchPage();

        return () => {
            cancelled = true;
        };
    }, [openModal, userNotifications.page]);

    return (
        <Modal
            title={
                <>
                    <NotificationsIcon /> {' Notifications'}
                </>
            }
            openModal={openModal}
            closeModal={closeModal}
            width="sm"
            contentNoPadding
            dialogActions={
                <>
                    <Button onClick={closeModal}>Close</Button>
                </>
            }
        >
            <Box sx={{ backgroundColor: '#f4f6f8', p: '24px 24px 16px' }}>
                {userNotifications.notificationsList.map((userNotification, key) => (
                    <Paper key={userNotification.activityLogID || key} square sx={{ mb: '8px' }}>
                        <Box
                            sx={{
                                padding: '16px',
                                borderLeft: '3px solid',
                                borderColor: 'secondary.main',
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Typography variant="h5">
                                    {userNotification.targetEntity || userNotification.entity}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: 'text.secondary',
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    <AccessTimeIcon
                                        sx={{ mr: '4px', fontSize: '20px' }}
                                    />
                                    <Box>
                                        {moment(
                                            userNotification.activityLogTime ||
                                                userNotification.time
                                        ).format('l - LT')}
                                    </Box>
                                </Typography>
                            </Box>

                            <Typography variant="body1" sx={{ mt: '8px' }}>
                                {userNotification.description}
                            </Typography>
                        </Box>
                    </Paper>
                ))}
                <Box sx={{ textAlign: 'center', py: '24px' }}>
                    {userNotifications.dataSize !== 0 && (
                        <LoadingButton
                            variant="outlined"
                            loading={loading}
                            endIcon={<DoubleArrowIcon />}
                            loadingPosition="end"
                            onClick={() =>
                                setUserNotifications((current) => ({
                                    ...current,
                                    page: current.page + 1,
                                }))
                            }
                        >
                            Load More
                        </LoadingButton>
                    )}
                </Box>
            </Box>
        </Modal>
    );
}

export default ModalNotifications;
